import makeStyles from '@mui/styles/makeStyles';

const styles = (theme) => ({

  date: () => {
    const styles = {
        flexDirection: 'column',
        marginBottom: '6px',
    };
    return styles;
  },


  label: () => {
    const styles = {
        fontSize: '12px',
        fontWeight: 'bold',
        lineHeight: '20px',
        minHeight: '16px',
        alignItems:' flex-end',
        margin: '0px',
        marginBottom: '8px',
        color: '#0C0644',
    };
 
    return styles;
  },

  dateFields: () => {
    const styles = {
        display: 'flex',
        flexDirection: 'row !important',
        justifyContent: 'center',
        marginTop: '4px',

    };
    return styles;
  },

  errorText: {
    display: 'flex',
    alignItems: 'center',
    color: '#B3261E',
    fontSize: '10px',
    fontWeight: 'bold',
    height: '22px',
    fontFamily: 'GothamRounded',
  },

  day: {
    width: '33%',
    marginRight: '8px',
  },

  month: {
    width: '33%',
    marginRight: '8px',
  },

  year: {
    width: '33%',
  },

});

export default styles;
export const useStyles = makeStyles(styles);
